export class MockStudents {
  static studentDetail: any = {
    avatarUrl: '',
    company: '',
    email: 'charlie.meredith@interapt.com',
    first_name: 'Charlie',
    id: 1000000,
    is_locked: false,
    last_name: 'Meredith',
    token: '',
    app_role_names: [{
      app: '',
      role: 'mobile_user',
      student: {
        groups: [{
          title: 'Group A',
          students: []
        }],
        id: 0,
        age: 25,
        organization: 'Heaven Hill',
        logged_in_seconds: 97200,
        archived: false,
        is_enrolled: true,
        score: 98,
        payload: [
          {
            field: 'Reason for taking the course',
            value: 'To learn about the Heaven Hill brand.'
          },
          {
            field: 'Work Experience',
            value: 'Sales Manager'
          }
        ],
        grades: [
          {
            percent: 84,
            exam: {
              title: 'Exam 1',
              id: 1
            }
          }, {
            percent: 61,
            exam: {
              title: 'Exam 2',
              id: 2
            }
          }, {
            percent: 12,
            exam: {
              title: 'Exam 3',
              id: 3
            }
          }, {
            percent: 99,
            exam: {
              title: 'Exam 4',
              id: 4
            }
          }, {
            percent: 100,
            exam: {
              title: 'Exam 5',
              id: 5
            }
          }, {
            percent: 0,
            exam: {
              title: 'Exam 6',
              id: 6
            }
          }, {
            percent: 99,
            exam: {
              title: 'Exam 7',
              id: 7
            }
          }, {
            percent: null,
            exam: {
              title: 'Exam 8',
              id: 8
            }
          }, {
            percent: 99,
            exam: {
              title: 'Exam 9',
              id: 9
            }
          }, {
            percent: 99,
            exam: {
              title: 'Exam 10',
              id: 10
            }
          }, {
            percent: 99,
            exam: {
              title: 'Exam 11',
              id: 11
            }
          }, {
            percent: 99,
            exam: {
              title: 'Exam 12',
              id: 12
            }
          }
        ]
      }
    }]
  };

  static students: any[] = [
    {
      avatarUrl: '',
      company: '',
      email: 'charlie.meredith@interapt.com',
      first_name: 'Charlie',
      id: 1000000,
      is_locked: false,
      last_name: 'Meredith',
      token: '',
      app_role_names: [{
        app: '',
        role: 'mobile_user',
        student: {
          groups: [{
            title: 'Group A',
            students: []
          }],
          id: 0,
          age: 25,
          organization: 'Heaven Hill',
          logged_in_seconds: 97320,
          archived: false,
          is_enrolled: true,
          score: 98,
          payload: [
            {
              field: 'Reason for taking the course',
              value: 'To learn about the Heaven Hill brand.'
            },
            {
              field: 'Work Experience',
              value: 'Sales Manager'
            }
          ],
          grades: [
            {
              percent: 84,
              exam: {
                title: 'Exam 1',
                id: 1
              }
            }, {
              percent: 61,
              exam: {
                title: 'Exam 2',
                id: 2
              }
            }, {
              percent: 12,
              exam: {
                title: 'Exam 3',
                id: 3
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 4',
                id: 4
              }
            }, {
              percent: 100,
              exam: {
                title: 'Exam 5',
                id: 5
              }
            }, {
              percent: 0,
              exam: {
                title: 'Exam 6',
                id: 6
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 7',
                id: 7
              }
            }, {
              percent: null,
              exam: {
                title: 'Exam 8',
                id: 8
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 9',
                id: 9
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 10',
                id: 10
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 11',
                id: 11
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 12',
                id: 12
              }
            }
          ]
        }
      }]
    },
    {
      avatarUrl: '',
      company: '',
      email: 'taylor.swift@interapt.com',
      first_name: 'Taylor',
      id: 2000000,
      is_locked: false,
      last_name: 'Swift',
      token: '',
      app_role_names: [{
        app: '',
        role: 'mobile_user',
        student: {
          groups: [{
            title: 'Group A',
            students: []
          }],
          id: 1,
          age: 24,
          organization: 'Hogwarts',
          logged_in_seconds: 460800,
          archived: false,
          is_enrolled: false,
          score: 53,
          payload: [
            {
              field: 'Reason for taking the course',
              value: 'Lsk dl ksdjfla djf laskdj flka lka skld alk sdflka sdlkf adlkf.'
            },
            {
              field: 'Academic History',
              value: 'Something blah la la di asid faoi jweio jeior wie riw ejrioaej re.'
            },
            {
              field: 'Work Experience',
              value: 'Interapt, Agent 511, Interapt, Humana, WFPK, Interapt, TEKY, etc etc.'
            }
          ],
          grades: [
            {
              percent: 84,
              exam: {
                title: 'Exam 1',
                id: 1
              }
            }, {
              percent: 61,
              exam: {
                title: 'Exam 2',
                id: 2
              }
            }, {
              percent: 12,
              exam: {
                title: 'Exam 3',
                id: 3
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 4',
                id: 4
              }
            }, {
              percent: 100,
              exam: {
                title: 'Exam 5',
                id: 5
              }
            }, {
              percent: 0,
              exam: {
                title: 'Exam 6',
                id: 6
              }
            }
          ]
        }
      }]
    },
    {
      avatarUrl: '',
      company: '',
      email: 'stefani@gmaii@interapt.com',
      first_name: 'Stefani',
      id: 3000000,
      is_locked: false,
      last_name: 'Germonatta',
      token: '',
      app_role_names: [{
        app: '',
        role: 'mobile_user',
        student: {
          groups: [{
            title: 'Group A',
            students: []
          }],
          id: 2,
          age: 30,
          organization: 'Hogwarts',
          logged_in_seconds: 0,
          archived: false,
          is_enrolled: true,
          score: 0,
          payload: [
            {
              field: 'Reason for taking the course',
              value: 'Lsk dl ksdjfla djf laskdj flka lka skld alk sdflka sdlkf adlkf.'
            },
            {
              field: 'Academic History',
              value: 'Something blah la la di asid faoi jweio jeior wie riw ejrioaej re.'
            },
            {
              field: 'Work Experience',
              value: 'Interapt, Agent 511, Interapt, Humana, WFPK, Interapt, TEKY, etc etc.'
            }
          ],
          grades: [
            {
              percent: 84,
              exam: {
                title: 'Exam 1',
                id: 1
              }
            }, {
              percent: 61,
              exam: {
                title: 'Exam 2',
                id: 2
              }
            }, {
              percent: 12,
              exam: {
                title: 'Exam 3',
                id: 3
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 4',
                id: 4
              }
            }, {
              percent: 100,
              exam: {
                title: 'Exam 5',
                id: 5
              }
            }, {
              percent: 0,
              exam: {
                title: 'Exam 6',
                id: 6
              }
            }
          ]
        }
      }]
    },
    {
      avatarUrl: '',
      company: '',
      email: 'bill.murray@gmail.com',
      first_name: 'Bill',
      id: 4000000,
      is_locked: false,
      last_name: 'Murray',
      token: '',
      app_role_names: [{
        app: '',
        role: 'mobile_user',
        student: {
          groups: [{
            title: 'Group C',
            students: []
          }],
          id: 3,
          age: 62,
          organization: 'Hogwarts',
          logged_in_seconds: 50400,
          archived: true,
          is_enrolled: false,
          score: 82,
          payload: [
            {
              field: 'Reason for taking the course',
              value: 'Lsk dl ksdjfla djf laskdj flka lka skld alk sdflka sdlkf adlkf.'
            },
            {
              field: 'Academic History',
              value: 'Something blah la la di asid faoi jweio jeior wie riw ejrioaej re.'
            },
            {
              field: 'Work Experience',
              value: 'Interapt, Agent 511, Interapt, Humana, WFPK, Interapt, TEKY, etc etc.'
            }
          ],
          grades: [
            {
              percent: 84,
              exam: {
                title: 'Exam 1',
                id: 1
              }
            }, {
              percent: 61,
              exam: {
                title: 'Exam 2',
                id: 2
              }
            }, {
              percent: 12,
              exam: {
                title: 'Exam 3',
                id: 3
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 4',
                id: 4
              }
            }, {
              percent: 100,
              exam: {
                title: 'Exam 5',
                id: 5
              }
            }, {
              percent: 0,
              exam: {
                title: 'Exam 6',
                id: 6
              }
            }
          ]
        }
      }]
    },
    {
      avatarUrl: '',
      company: '',
      email: 'jlaw@gmail.com',
      first_name: 'Jennifer',
      id: 5000000,
      is_locked: false,
      last_name: 'Lawrence',
      token: '',
      app_role_names: [{
        app: '',
        role: 'mobile_user',
        student: {
          groups: [{
            title: 'Group B',
            students: []
          }],
          id: 4,
          age: 26,
          organization: 'Hogwarts',
          logged_in_seconds: 118800,
          archived: true,
          is_enrolled: true,
          score: 61,
          payload: [
            {
              field: 'Reason for taking the course',
              value: 'Lsk dl ksdjfla djf laskdj flka lka skld alk sdflka sdlkf adlkf.'
            },
            {
              field: 'Academic History',
              value: 'Something blah la la di asid faoi jweio jeior wie riw ejrioaej re.'
            },
            {
              field: 'Work Experience',
              value: 'Interapt, Agent 511, Interapt, Humana, WFPK, Interapt, TEKY, etc etc.'
            }
          ],
          grades: [
            {
              percent: 84,
              exam: {
                title: 'Exam 1',
                id: 1
              }
            }, {
              percent: 61,
              exam: {
                title: 'Exam 2',
                id: 2
              }
            }, {
              percent: 12,
              exam: {
                title: 'Exam 3',
                id: 3
              }
            }, {
              percent: 99,
              exam: {
                title: 'Exam 4',
                id: 4
              }
            }, {
              percent: 100,
              exam: {
                title: 'Exam 5',
                id: 5
              }
            }, {
              percent: 0,
              exam: {
                title: 'Exam 6',
                id: 6
              }
            }
          ]
        }
      }]
    }
  ]
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/student/mock-students.ts